import { createElement } from "react";
import { fmt, humanize, Empty, StatTile } from "./kit";

const HIDE = new Set(["id", "_id", "team_id", "player_id", "game_id", "recruiter_id", "created_at", "updated_at", "photo_path"]);
const isPrim = (v) => v === null || ["string", "number", "boolean"].includes(typeof v);

export const AutoTable = ({ rows, testid }) => {
  const cols = [];
  rows.slice(0, 20).forEach((r) =>
    Object.entries(r ?? {}).forEach(([k, v]) => { if (!HIDE.has(k) && isPrim(v) && !cols.includes(k)) cols.push(k); })
  );
  if (!rows.length) return <Empty />;
  return (
    <div data-testid={testid} className="overflow-x-auto rounded-xl border border-[#1E293B]">
      <table className="w-full min-w-max text-left text-sm">
        <thead className="bg-[#162032]">
          <tr>{cols.slice(0, 16).map((c) => <th key={c} className="px-3 py-2 font-mono-gd text-[11px] uppercase tracking-wider text-slate-400">{humanize(c)}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r?.id ?? i} className="border-t border-[#1E293B] hover:bg-[#162032]/60">
              {cols.slice(0, 16).map((c) => <td key={c} className="px-3 py-2 font-mono-gd text-slate-200">{fmt(r?.[c])}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const AutoData = ({ value, depth = 0, testid }) => {
  if (value === null || value === undefined) return <Empty />;
  if (Array.isArray(value)) {
    if (!value.length) return <Empty />;
    if (value.every(isPrim)) return <p className="text-slate-200">{value.join(", ")}</p>;
    return <AutoTable rows={value} testid={testid} />;
  }
  if (isPrim(value)) return <p className="font-mono-gd text-slate-200">{fmt(value)}</p>;
  const entries = Object.entries(value).filter(([k]) => !HIDE.has(k));
  const prims = entries.filter(([, v]) => isPrim(v));
  const nested = entries.filter(([, v]) => !isPrim(v));
  return (
    <div data-testid={testid} className="space-y-6">
      {prims.length > 0 && (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {prims.map(([k, v]) => <StatTile key={k} label={humanize(k)} value={fmt(v)} />)}
        </div>
      )}
      {nested.map(([k, v]) => (
        <div key={k}>
          <h3 className="mb-3 font-display text-xl font-bold uppercase tracking-wide text-white">{humanize(k)}</h3>
          {depth < 3 ? createElement(AutoData, { value: v, depth: depth + 1 }) : null}
        </div>
      ))}
    </div>
  );
};
